import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import moment from 'moment';

import { getContent } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import API_MASTER_DATA from '../../../api/apiMasterData';
import WhiteContainer from '../../../components/Container/WhiteContainer';
import IconGear from '../../../assets/icons/IconGear';
import ActionType from '../../../redux/reducer/globalActionType';
import MasterDataAuditDetail from '../../../components/MasterData/MasterDataAuditDetail';
import MasterDataRolePermission from '../../../components/MasterData/MasterDataRolePermission';
import { CheckPermissionComponent } from '../../../util/permission';
import { MASTER_DATA_ROLE_VIEW } from '../../../constants/menuPermissionConstant';

class RoleDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            roleDetail: {},
            createdAt: '',
            updatedAt: '',
            permissionPage: false
        }
    }

    getDetailRole = () => {
        API_MASTER_DATA.getDetailRole(this.props.match.params.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        roleDetail: getContent(res),
                        createdAt: moment.utc(getContent(res).created_at).format('DD MMMM YYYY HH:mm'),
                        updatedAt: moment.utc(getContent(res).updated_at).format('DD MMMM YYYY HH:mm'),
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleTogglePermission = () => {
        this.setState({
            permissionPage: !this.state.permissionPage
        })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getDetailRole();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_ROLE_VIEW]} userPermission={this.props.userDetail.permissions}>
                {
                    this.state.roleDetail.permission &&
                    <div className={this.state.permissionPage ? "block" : "hidden"}>
                        <MasterDataRolePermission
                            action="detail"
                            permission={this.state.roleDetail.permission}
                            handleTogglePermission={this.handleTogglePermission}
                        />
                    </div>
                }

                <div className={this.state.permissionPage ? "hidden" : "role-container"}>
                    <div className="role-detail">
                        <div className="flex justify-between">
                            <div></div>
                            <button type="button" id="btnpermission" className="rounded-full bg-white text-darkblue border-2 border-white font-bold px-5 py-2 ml-auto mb-3 flex items-center" onClick={() => this.handleTogglePermission()}>
                                <div className="bg-darkblue rounded-full flex justify-center items-center h-5 w-5 p-1">
                                    <IconGear />
                                </div>
                                <div className="ml-1">
                                    Izin Pengaturan
                                </div>
                            </button>
                        </div>
                        <WhiteContainer>
                            <div className="flex">
                                <div className="w-1/2 p-10 kiri">
                                    <div className="flex justify-between w-full mb-5">
                                        <div className="w-1/6 pr-5 text-right">
                                            <label className="select-none font-medium text-gray-400" htmlFor="tslroleid">Role ID</label>
                                        </div>
                                        <div className="w-5/6">
                                            <input
                                                type="text"
                                                id="tslroleid"
                                                name="roleId"
                                                className="form-control"
                                                defaultValue={this.state.roleDetail.role_id}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="flex justify-between w-full mb-5">
                                        <div className="w-1/6 pr-5 text-right">
                                            <label className="select-none font-medium text-gray-400" htmlFor="tmlroledescription">Deskripsi</label>
                                        </div>
                                        <div className="w-5/6">
                                            <textarea
                                                id="tmlroledescription"
                                                name="roleDescription"
                                                className="form-control resize-none h-48 2xl:h-40"
                                                defaultValue={this.state.roleDetail.description}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="flex justify-between w-full mb-5">
                                        <div className="w-1/6 pr-5 text-right">
                                            <label className="select-none font-medium text-gray-400" htmlFor="ddsrolecategory">Kategori Role</label>
                                        </div>
                                        <div className="w-5/6">
                                            <Select
                                                id="ddsrolecategory"
                                                isDisabled={true}
                                                value={{ label: this.state.roleDetail.level, value: this.state.roleDetail.level }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <MasterDataAuditDetail
                                    createdAt={this.state.createdAt}
                                    updatedAt={this.state.updatedAt}
                                    modifiedBy={this.state.roleDetail.modified_by}
                                />
                            </div>
                            <button
                                type="button"
                                id="btnclose"
                                className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-2 mt-3 ml-2 absolute bottom-5 right-5"
                                onClick={() => this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_ROLE)}
                            >
                                Tutup
                            </button>
                        </WhiteContainer>
                    </div>
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleDetail);